import dayjs from 'dayjs';
import { useGetBlogPostsQuery } from './generated';
import { cleanHTML } from '@/utils/string';

export type BlogPost = {
	date: string;
	id: string;
	title: string;
	to: string;
	intro: string;
	label: string;
	image: {
		alt: string;
		src: string;
	};
};

export async function getBlogPosts() {
	const fetchAllPosts = useGetBlogPostsQuery.fetcher();

	const posts = await fetchAllPosts();

	const now = new Date();

	if (!posts.posts?.nodes) {
		throw new Error('No posts found. Expected at least one post.');
	}

	const filtered = posts.posts.nodes.map((post) => {
		const dateData = post?.date ? new Date(post.date) : now;

		return {
			id: post?.id || '',
			date: dayjs(dateData).format('DD. MM. YYYY'),
			title: post?.title || '',
			to: post?.link || '',
			intro: cleanHTML(post?.excerpt || ''),
			label: post?.tags?.nodes?.[0]?.name || '',
			image: {
				alt: cleanHTML(post?.featuredImage?.node?.caption || ''),
				src: post?.featuredImage?.node?.mediaItemUrl || '',
			},
		};
	}) satisfies BlogPost[];

	return filtered;
}
